import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query SearchContainerQuery(
    $startRow: Int
    $endRow: Int
    $sortModel: [Sort]
    $Invoicesfilters: [Filter]
    $SearchInvoices: Boolean!
    $SearchInvoicesCount: Boolean!
    $HouseEntrancesfilters: [Filter]
    $SearchHouseEntrances: Boolean!
    $SearchHouseEntrancesCount: Boolean!
    $Appointmentsfilters: [Filter]
    $SearchAppointments: Boolean!
    $SearchAppointmentsCount: Boolean!
    $Tenantsfilters: [Filter]
    $TenantsSubfilters: [Filter]
    $SearchTenants: Boolean!
    $SearchTenantsCount: Boolean!
    $CustomerNumbersfilters: [Filter]
    $SearchCustomerNumbers: Boolean!
    $SearchCustomerNumbersCount: Boolean!
    $companyId: ID!
  ) {
    Me {
      id
      Company(id: $companyId) {
        CountInvoicesSearch: countInvoices(
          options: { filters: $Invoicesfilters }
        ) @include(if: $SearchInvoicesCount)
        InvoicesSearch: Invoices(
          options: {
            startRow: $startRow
            endRow: $endRow
            sorting: $sortModel
            filters: $Invoicesfilters
          }
        ) @include(if: $SearchInvoices) {
          id
          tableId
          invoiceNumber
          name
        }
        CountHouseEntrancesSearch: countHouseEntrances(
          options: { filters: $HouseEntrancesfilters }
        ) @include(if: $SearchHouseEntrancesCount)
        HouseEntrancesSearch: HouseEntrances(
          options: {
            startRow: $startRow
            endRow: $endRow
            sorting: $sortModel
            filters: $HouseEntrancesfilters
          }
        ) @include(if: $SearchHouseEntrances) {
          id
          tableId
          address {
            street
            zip
            city
            number
          }
        }
        CountAppointmentsSearch: countAppointments(
          options: { filters: $Appointmentsfilters }
        ) @include(if: $SearchAppointmentsCount)
        AppointmentsSearch: Appointments(
          options: {
            startRow: $startRow
            endRow: $endRow
            sorting: $sortModel
            filters: $Appointmentsfilters
          }
        ) @include(if: $SearchAppointments) {
          id
          tableId
          referenceNumber
          tenant {
            id
            firstname
            lastname
            fullname
          }
          address {
            street
            zip
            city
            number
          }
        }
        CountTenantsSearch: countUsageUnits(
          options: { filters: $Tenantsfilters }
        ) @include(if: $SearchTenantsCount)
        TenantsSearch: UsageUnits(
          options: {
            startRow: $startRow
            endRow: $endRow
            sorting: $sortModel
            filters: $Tenantsfilters
          }
        ) @include(if: $SearchTenants) {
          id
          tableId
          referenceNumber
          tenants(
            options: {
              startRow: $startRow
              endRow: $endRow
              sorting: $sortModel
              filters: $TenantsSubfilters
            }
          ) {
            id
            tableId
            firstname
            lastname
            fullname
          }
          address {
            street
            zip
            city
            number
          }
        }
        CountCustomerNumbersSearch: countUsageUnits(
          options: { filters: $CustomerNumbersfilters }
        ) @include(if: $SearchCustomerNumbersCount)
        CustomerNumbersSearch: UsageUnits(
          options: {
            startRow: $startRow
            endRow: $endRow
            sorting: $sortModel
            filters: $CustomerNumbersfilters
          }
        ) @include(if: $SearchCustomerNumbers) {
          id
          tableId
          referenceNumber
          address {
            street
            zip
            city
            number
          }
        }
      }
    }
  }
`
